import script from "./List.vue?vue&type=script&lang=ts&setup=true"
export * from "./List.vue?vue&type=script&lang=ts&setup=true"

import "./List.vue?vue&type=style&index=0&id=32e6816a&scoped=true&lang=less"

import exportComponent from "D:\\Code\\BranchManageSystem\\UI\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32e6816a"]])

export default __exports__